import React from 'react';
import { FDBox, FDStack } from '@facet-wealth/design';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';
import {
  buildUseStyles,
  useTheme,
} from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';

const useStyles = buildUseStyles('GoalStrategyDetailsSkeleton', (theme) => ({
  skeleton: {
    borderRadius: theme.radius.md,
  },
}));

const GoalStrategyDetailsSkeleton = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  return (
    <FDStack direction={'column'} alignItems={'center'} spacing={2} width={'100%'}>
      <Skeleton className={classes.skeleton} variant={'rect'} width={250} height={65} />
      <Skeleton className={classes.skeleton} variant={'rect'} width={'100%'} height={isMobile ? 350 : 120} />
      <Skeleton className={classes.skeleton} variant={'rect'} width={'100%'} height={isMobile ? 350 : 120} />
      <FDBox height={isMobile ? 24 : 48} />
      <Skeleton className={classes.skeleton} variant={'rect'} width={'100%'} height={400} />
    </FDStack>
  );
};

GoalStrategyDetailsSkeleton.defaultProps = {};

GoalStrategyDetailsSkeleton.propTypes = {};

export { GoalStrategyDetailsSkeleton };
